import { createContext } from 'preact';
import { useContext } from 'preact/hooks';
import type { App } from '../app';

export const AppContext = createContext<App | null>(null);

/** The App controller (actions and game data) for the screens. */
export function useApp(): App {
  const app = useContext(AppContext);
  if (!app) throw new Error('useApp outside of <AppContext.Provider>');
  return app;
}
